const testimonials = [
  {
    id: 1,
    name: 'Igor Strelov',
    title: 'Front-end JavaScript Dev',
    org: 'GeekBrains',
    desc: 'Maks is a person of commitment. He is really good at what he is doing. I really like his work. Especially the unique point of view of designing.',
  },
  {
    id: 2,
    name: 'Kirill Gusev',
    title: 'Full Stack JavaScript Dev',
    org: 'GeekBrains',
    desc: 'Really amazing communication skills. Always understand what I am trying to achieve. Also, his work is really amazing. Do really high-quality work.',
  },
  {
    id: 3,
    name: 'Alexander Horopchanu',
    title: 'Full Stack JavaScript Dev',
    org: 'Eclipse digital studio',
    desc: 'Really hard-working person. Deliver the work as promised. Planning to work more with this person.',
  },
];
export default testimonials;
